import Vue from 'vue';

const state = Vue.observable({
  user: null
});

export default {
  state,

  get user() {
    return state.user;
  },

  set user(user) {
    state.user = user;
  },

  setUser(user) {
    state.user = user;
  },

  clear() {
    state.user = null;
  },

  isLoggedIn() {
    return !!state.user;
  },

  isOuvreur() {
    return state.user && state.user.role === 'ouvreur';
  },

  isAdmin() {
    return state.user && state.user.role === 'admin';
  }
};
